import React from "react";
import { useOutlet } from "react-router-dom";
import EmailUpdates from "./EmailUpdates";

const EmailUpdatesLayout: React.FC = () => {
  const outlet = useOutlet();
  return (
    <div className="p-3 sm:p-6">
      <div style={{ display: outlet ? "none" : "block" }}>
        <EmailUpdates />
      </div>
      {outlet}
    </div>
  );
};

export default EmailUpdatesLayout;
